import PropTypes from 'prop-types';
import PageLink from '../pageLink';

const AdditionalDetails = ({
	title,
	description,
	columns,
	sectionClassName = '',
	titleClassName = '',
}) => {
	const descriptionFormatted = description?.childMarkdownRemark?.html;
	return (
		<div className="additional-details section">
			<div
				className={`additional-details__content section__content bg--light-gray ${sectionClassName}`}
			>
				<h2
					className={`additional-details__title typography typography--h2 typography--secondary ${titleClassName}`}
				>
					{title}
				</h2>
				<div
					className="additional-details__body typography typography--body typography--tertiary"
					dangerouslySetInnerHTML={{ __html: descriptionFormatted }}
				/>
				{columns && (
					<div className="additional-details__items">
						{columns.map(({ id, title, links }) => (
							<div className="additional-details__items-element" key={id}>
								<h3 className="additional-details__items-element-title typography typography--h6 typography--black">
									{title}
								</h3>
								<ul className="additional-details__items-element-list">
									{links.map((item) => {
										let content;
										if (
											item?.type === 'ContentfulContentFragmentCta'
										) {
											content = (
												<PageLink
													className="typography typography--secondary"
													to={item?.link}
												>
													{item?.title}
												</PageLink>
											);
										}

										return (
											<li
												key={item.id}
												className="additional-details__items-element-link"
											>
												{content}
											</li>
										);
									})}
								</ul>
							</div>
						))}
					</div>
				)}
			</div>
		</div>
	);
};

AdditionalDetails.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.object,
	columns: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string,
			title: PropTypes.string,
			links: PropTypes.arrayOf(PropTypes.object),
		})
	),
	sectionClassName: PropTypes.string,
	titleClassName: PropTypes.string,
};

export default AdditionalDetails;
